import { Controller } from "@hotwired/stimulus"
import { showTurnOnWarning } from "../lib/turn_on_warning"

// A form whose ONE marked submit button turns on something billed to the
// agent's CRM wallet, so it shows the turn-on warning first (#20242): accepting
// an agency owner's call-recording request. The warning (Voice::TurnOnWarning)
// is the same popup the recording and transcription switches show
// (lib/turn_on_warning.js). Other submit buttons (Decline) go straight through.
//
// The modal is async and submit is not, so the marked submit is prevented and
// re-issued with the SAME button on "Turn On" — requestSubmit(submitter) keeps
// its name/value (decision=accept) in the form data — guarded so the re-issued
// submit is not prompted again. "Keep Off", or a dialog that cannot open,
// submits nothing (fail closed).
//
//   = form_with ..., data: { controller: 'submit-on-warning',
//       action: 'submit->submit-on-warning#confirm',
//       submit_on_warning_warning_value: warning.to_json }
//     = gl_button 'Accept…', data: { submit_on_warning_ask: true }
export default class extends Controller {
  static values = { warning: Object }

  #confirmed = false
  #prompting = false

  confirm (event) {
    if (this.#confirmed) {
      this.#confirmed = false
      return
    }
    const submitter = event.submitter
    if (!submitter?.hasAttribute("data-submit-on-warning-ask") || !this.warningValue.title) return

    event.preventDefault()
    if (this.#prompting) return

    this.#prompting = true
    showTurnOnWarning(this.warningValue)
      .then(
        (accepted) => {
          if (!accepted || !this.element.isConnected) return

          this.#confirmed = true
          try {
            this.element.requestSubmit(submitter)
          } catch (error) {
            this.#confirmed = false
            console.error("submit-on-warning: submitting the confirmed form failed", error)
          }
        },
        (error) => {
          // Fail CLOSED: a warning that never appeared is not consent.
          console.error("submit-on-warning: confirmation dialog failed", error)
        }
      )
      .finally(() => {
        this.#prompting = false
      })
  }
}
